// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type InfoCircle48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const InfoCircle48: FC<InfoCircle48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M25.65 34h-3V22h3v12ZM25.175 17.84c-.317.307-.709.46-1.176.46-.467 0-.859-.153-1.175-.46a1.525 1.525 0 0 1-.474-1.14c0-.482.158-.885.475-1.211A1.574 1.574 0 0 1 24.001 15c.467 0 .859.163 1.175.489.316.326.474.73.474 1.211 0 .453-.158.833-.475 1.14Z" />
            <path
                d="M42 24c0 9.941-8.059 18-18 18S6 33.941 6 24 14.059 6 24 6s18 8.059 18 18Zm-3 0c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default InfoCircle48;
